import React, { useState } from "react";
import { TableContext } from "../../index";
import { debug } from "../../utils";
import { useHistory } from "react-router-dom";
import DomainNameCardModal from "./DomainNameCardModal";
import DomainManagementTableHeader from "./DomainManagementTableHeader";
import DomainManagementTable from "./DomainManagementTable";
import PaginationManager from "../../view/PaginationManager";
import * as domainManagementService from "./domainManagementService";

function DomainManagementSection(props) {

    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [modalProps, setModalProps] = useState({});

    const handleShowModal = (props) => {
        setModalProps(props);
        setShowModal(true);
    }

    const initTableConfig = {
        selected: [],
        results: [],
        allResults: [],
        showModal: handleShowModal
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        //alert (config)
        setTableConfig(config);
    }

    const onCloseModal = () => {
        //history.go(0);
        setTableConfig({ ...tableConfig, lastUpdated: Date.now() });
        setShowModal(false);
    }

    return (
        <>
            {showModal && <DomainNameCardModal handleClose={onCloseModal} {...modalProps} />}
            <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
                <div key={history.location}>
                    <DomainManagementTableHeader />
                    <div className="card-body">
                        <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                            <div className="row">
                                <div className="col-sm-12">
                                    <DomainManagementTable />
                                    <PaginationManager
                                        getPage={domainManagementService.listPageable}
                                        blocked={tableConfig.filtersLoading} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </TableContext.Provider>
        </>
    )
}

export default DomainManagementSection;
